import { FC } from 'react';

import { Button } from 'antd';
import { motion } from 'framer-motion';

import Alert from 'components/Alert/Alert';

import { AlertType } from 'constants/enums';

import { useTranslation } from 'react-i18next';
import { standardAnimationProps } from '../../../constants/animations';
import styles from './CancelInterviewConfirmation.module.scss';

interface CancelInterviewConfirmationProps {
  onBackClick: () => void;
  onConfirm: () => Promise<void>;
  isLoading: boolean;
}

const CancelInterviewConfirmation: FC<CancelInterviewConfirmationProps> = ({
  onBackClick,
  onConfirm,
  isLoading
}) => {
  const { t } = useTranslation()

  return <motion.div {...standardAnimationProps}>
    <div className={styles.title}>{t('sidebar.application.interview.cancel.title')}</div>

    <Alert type={AlertType.Warning} className={styles.message}>
      {t('sidebar.application.interview.cancel.areYouSure')}
    </Alert>

    <div className={styles.actions}>
      <Button
        type="link"
        danger
        onClick={onBackClick}
        className={styles.backButton}
        disabled={isLoading}
      >
        {t('common.back')}
      </Button>
      <Button
        type="primary"
        danger
        onClick={onConfirm}
        className={styles.cancelButton}
        loading={isLoading}
      >
        {t('common.cancel')}
      </Button>
    </div>
  </motion.div>
};

export default CancelInterviewConfirmation;
